export enum RetailersEnum {
    COSTCO = 'costco'
}